
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-chat-enhancement-demo-think","docs-x-markdown-chat-enhancement-demo-sources"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.en-US.md?type=demo')
};